// extracted by mini-css-extract-plugin
    if(module.hot) {
      (function() {
        var localsJsonString = undefined;
        // 1768277226440
        var cssReload = require("../../../../node_modules/.pnpm/mini-css-extract-plugin@2.9.4_webpack@5.104.1_webpack-cli@4.10.0_/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  